import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function Confirmation(props) {
    const [text, setText] = useState(props.text)
        
    return (
        <Dialog open={props.text} onClose={() => {props.onClose()}} fullWidth maxWidth="xs" >
            <DialogTitle id="alert-dialog-title">
                {props.title ?? 'Information'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    )
}